/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenRangeDTO } from './OpenRangeDTO';
import {
    OpenRangeDTOFromJSON,
    OpenRangeDTOFromJSONTyped,
    OpenRangeDTOToJSON,
} from './OpenRangeDTO';
import type { SeriesValuesRequestSeries } from './SeriesValuesRequestSeries';
import {
    SeriesValuesRequestSeriesFromJSON,
    SeriesValuesRequestSeriesFromJSONTyped,
    SeriesValuesRequestSeriesToJSON,
} from './SeriesValuesRequestSeries';

/**
 * 
 * @export
 * @interface SeriesValuesRequest
 */
export interface SeriesValuesRequest {
    /**
     * 
     * @type {string}
     * @memberof SeriesValuesRequest
     */
    order?: SeriesValuesRequestOrderEnum;
    /**
     * 
     * @type {number}
     * @memberof SeriesValuesRequest
     */
    perSeriesPointsLimit?: number;
    /**
     * 
     * @type {Array<SeriesValuesRequestSeries>}
     * @memberof SeriesValuesRequest
     */
    requests: Array<SeriesValuesRequestSeries>;
    /**
     * 
     * @type {number}
     * @memberof SeriesValuesRequest
     */
    sizeLimitBytes?: number;
    /**
     * 
     * @type {OpenRangeDTO}
     * @memberof SeriesValuesRequest
     */
    stepRange?: OpenRangeDTO;
}


/**
 * @export
 */
export const SeriesValuesRequestOrderEnum = {
    Ascending: 'ascending',
    Descending: 'descending'
} as const;
export type SeriesValuesRequestOrderEnum = typeof SeriesValuesRequestOrderEnum[keyof typeof SeriesValuesRequestOrderEnum];


/**
 * Check if a given object implements the SeriesValuesRequest interface.
 */
export function instanceOfSeriesValuesRequest(value: object): value is SeriesValuesRequest {
    if (!('requests' in value) || value['requests'] === undefined) return false;
    return true;
}

export function SeriesValuesRequestFromJSON(json: any): SeriesValuesRequest {
    return SeriesValuesRequestFromJSONTyped(json, false);
}

export function SeriesValuesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValuesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'order': json['order'] == null ? undefined : json['order'],
        'perSeriesPointsLimit': json['perSeriesPointsLimit'] == null ? undefined : json['perSeriesPointsLimit'],
        'requests': ((json['requests'] as Array<any>).map(SeriesValuesRequestSeriesFromJSON)),
        'sizeLimitBytes': json['sizeLimitBytes'] == null ? undefined : json['sizeLimitBytes'],
        'stepRange': json['stepRange'] == null ? undefined : OpenRangeDTOFromJSON(json['stepRange']),
    };
}

export function SeriesValuesRequestToJSON(value?: SeriesValuesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'order': value['order'],
        'perSeriesPointsLimit': value['perSeriesPointsLimit'],
        'requests': ((value['requests'] as Array<any>).map(SeriesValuesRequestSeriesToJSON)),
        'sizeLimitBytes': value['sizeLimitBytes'],
        'stepRange': OpenRangeDTOToJSON(value['stepRange']),
    };
}

